import React from 'react'
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import PatientInformation from './Components/PatientInformation'
import Summary from "./Components/Tabs/Summary/Summary"
import History from "./Components/Tabs/History/History"
import Templates from "./Components/Tabs/Templates/Templates"
import PastEncounters from "./Components/Tabs/PastEncounters/PastEncounters"

const EncounterLeftPortion = ({ enCounterData, data, expandAll, setIsRecordSaved, setTemplateDataToApply, ...props }) => {

  return (<>
    <div className="encounter_summary-content">
    <PatientInformation data={data?.PatientData?.[0] || null} enCounterData={enCounterData || null}  setIsRecordSaved={setIsRecordSaved}/>
    <div className='encounters-tabs'>
        <Tab.Container defaultActiveKey="Summary">
            <Nav variant="tabs" className="d-flex border-0 gx-0 gap-1  flex-nowrap hover-scrollbar mb-2 px-2 mt-2">
                <Nav.Item className="">
                    <Nav.Link eventKey="Summary" className="text font-m text-nowrap">Summary</Nav.Link>
                </Nav.Item>
                <Nav.Item className="">
                    <Nav.Link eventKey="History" className="text font-m text-nowrap">History</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item className="">
                    <Nav.Link eventKey="Templates" className="text font-m text-nowrap">Templates</Nav.Link>
                </Nav.Item> */}
                <Nav.Item className="">
                    <Nav.Link eventKey="PastEncounters" className="text font-m text-nowrap">Past Encounters</Nav.Link>
                </Nav.Item>
            </Nav>
            <Tab.Content className="content-scroll hover-scrollbar">
                <Tab.Pane eventKey='Summary'>
                    <Summary expandAll={expandAll} data={data} setIsRecordSaved={setIsRecordSaved} setIsRecordSavedType={props?.setIsRecordSavedType} patientID = {props?.patientID} />
                </Tab.Pane>

                <Tab.Pane eventKey='History'>
                    <History expandAll={expandAll} {...props} patientID = {props?.patientID} />
                </Tab.Pane>

                {/* <Tab.Pane eventKey='Templates'>
                    <Templates expandAll={expandAll} setTemplateDataToApply={setTemplateDataToApply} patientID = {props?.patientID}/>
                </Tab.Pane> */}

                <Tab.Pane eventKey='PastEncounters'
                 mountOnEnter
                 >
                    <PastEncounters expandAll={expandAll}  {...props} patientID = {props?.patientID} />
                </Tab.Pane>
            </Tab.Content>
        </Tab.Container>
    </div>

    </div>
</>
  )
}

export default EncounterLeftPortion